import { render, staticRenderFns } from "./DialogSimulation.vue?vue&type=template&id=db68c5a2&scoped=true"
import script from "./DialogSimulation.vue?vue&type=script&lang=js"
export * from "./DialogSimulation.vue?vue&type=script&lang=js"
import style0 from "./DialogSimulation.vue?vue&type=style&index=0&id=db68c5a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db68c5a2",
  null
  
)

export default component.exports